import Button from './v1';
import ButtonV2 from './v2';
import { VARIENT } from './constant';

export {
  Button,
  ButtonV2,
  VARIENT,
};

export default Button;
